export const round = (value: number, decimalCount = 5) => {
  const precision = Math.pow(10, decimalCount);
  return Math.round(value * precision) / precision;
};
